import React, { FC } from "react";
import { TableHead as MuiTableHead, TableHeadProps } from "@mui/material";

const TableHead: FC<TableHeadProps> = (props) => <MuiTableHead {...props} />;

export default TableHead;
